import { Component, type ErrorInfo, type ReactNode } from "react";
import { ErrorState, Panel, PanelBody } from "../ui";
import { forceFreshReload, isRecoverableChunkError, recoverFromChunkError } from "../../lib/chunkRecovery";

interface Props {
  children: ReactNode;
}

interface State {
  error: unknown;
  recovering: boolean;
}

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { error: null, recovering: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, recovering: isRecoverableChunkError(error) };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo) {
    console.error("[Etheria] React render failure", error, info);
    if (recoverFromChunkError(error)) return;
  }

  override render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="mx-auto flex min-h-[70dvh] w-full max-w-3xl items-center px-4 py-12">
        <Panel className="w-full">
          <PanelBody>
            <ErrorState
              title={this.state.recovering ? "Actualisation du grimoire" : "Page indisponible"}
              message={
                this.state.recovering
                  ? "Le site vient de recevoir une nouvelle version. La page se recharge automatiquement."
                  : "Une erreur a empeche cette page de s'afficher correctement."
              }
              onRetry={forceFreshReload}
            />
          </PanelBody>
        </Panel>
      </main>
    );
  }
}
